export default __webpack_public_path__ + "static/buyers-edge-107x68-88790fc17eac087d421211bf8fdeb41d.webp";